function PlanToast({ planToastMessage, isMobile, lowPosition }) {  if (!planToastMessage) return null;
  return (
    <div
      style={{
        position: "fixed",
        left: "50%",
        bottom: lowPosition ? "24px" : isMobile ? "92px" : "28px",
        transform: "translateX(-50%)",
        zIndex: 9999,
        width: "calc(100% - 32px)",
        maxWidth: "360px",
        pointerEvents: "none"
      }}
    >
      <div
        style={{
          padding: "14px 16px",
          borderRadius: "18px",
          background: "rgba(15, 23, 42, 0.82)",
          color: "#ffffff",
          textAlign: "center",
          fontSize: "14px",
          fontWeight: "600",
          backdropFilter: "blur(16px) saturate(180%)",
          WebkitBackdropFilter: "blur(16px) saturate(180%)",
          boxShadow: "0 14px 32px rgba(15, 23, 42, 0.22)",
          border: "1px solid rgba(255,255,255,0.12)",
          animation: "fadeInModal 0.2s ease"
        }}
      >
        {planToastMessage}
      </div>
    </div>
  );
}

export default PlanToast;